import { FundriseRouteConfig } from 'vue-router';
import { genericErrorToast } from '@constants/toasts';
import { includesRequiredQueryParams } from '@utils/request';
import { useAppStore } from '@stores/app';

const oauthAuthorizationRoutes: Array<FundriseRouteConfig> = [
	{
		path: `/oauth/authorize`,
		name: 'oauth-authorize',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: (to, from, next) => {
			const hasRequiredParams = includesRequiredQueryParams(['client_id', 'redirect_uri', 'response_type'], to);
			if (hasRequiredParams) {
				next();
			} else {
				const appStore = useAppStore();
				appStore.addToast(genericErrorToast);
				next({ name: 'account-overview' });
			}
		},
		component: () => import('@views/oauth-authorization/oauth-authorization.vue')
	}
];
export default oauthAuthorizationRoutes;
